module.exports = __webpack_public_path__ + "img/my-apps.010eec24.svg";